import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Awards
 */

export default defineSlotRecipe({
    slots: ['root', 'awardsGroup', 'award', 'awardImage', 'awardText', 'copy'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'spacing-32',
            paddingTop: {base: 'spacing-64', s: 'spacing-128'},
            paddingBottom: {base: 'spacing-40', s: 'spacing-128'},
            paddingX: {base: 6, s: 64, l: 80}
        },
        copy: {
            textStyle: 'display.xsmall',
            textAlign: 'center'
        },
        awardsGroup: {
            display: 'flex',
            flexDirection: 'row',
            paddingTop: {base: 'spacing-16', s: 'spacing-48'},
            paddingX: {base: 'spacing-16', s: 'spacing-64'},
            gap: {base: 'spacing-16', s: 'spacing-48'}
        },
        award: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-24',
            paddingX: {base: 'spacing-16', s: 'spacing-32'},
            '&:nth-of-type(3)': {display: {base: 'none', s: 'flex'}},
            '&:nth-of-type(n+4)': {display: 'none'}
        },
        awardImage: {
            width: {base: '6.75rem', s: '8.7rem'}
        },
        awardText: {
            color: 'text.primary',
            textStyle: 'display.xsmall',
            textAlign: 'center'
        }
    }
})
